webpackJsonp([194980118678574],{

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogNav = function (_Component) {
	  _inherits(BlogNav, _Component);
	
	  function BlogNav(props) {
	    _classCallCheck(this, BlogNav);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      isMobile: false,
	      navToggle: 'nav-hidden'
	    };
	
	    _this.blogNavDrop = _this.blogNavDrop.bind(_this);
	    return _this;
	  }
	
	  BlogNav.prototype.blogNavDrop = function blogNavDrop() {
	    var nav = this.state.navToggle === 'nav-hidden' ? 'nav-show' : 'nav-hidden';
	    this.setState({
	      navToggle: nav
	    });
	  };
	
	  BlogNav.prototype.render = function render() {
	    var categoryList = [];
	    var categoryFilter = this.props.categorySlug || 'All';
	
	    if (this.props.drupalCategory) {
	      categoryList = this.props.drupalCategory.map(function (cat, ind) {
	        var category = cat.node.title.toLowerCase();
	        var highlightCat = categoryFilter === cat.node.title ? 'highlight' : '';
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'blog--category ' + highlightCat, key: ind },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/updates/category/' + category },
	            cat.node.title
	          )
	        );
	      });
	    }
	
	    var allHighlight = categoryFilter === 'All' ? 'highlight' : '';
	
	    var allItem = _react2.default.createElement(
	      'div',
	      { className: 'blog--category ' + allHighlight, key: 200 },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/updates' },
	        'All'
	      )
	    );
	
	    var blogNav = [allItem].concat(categoryList);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'blog--nav' },
	      _react2.default.createElement(
	        'div',
	        { className: 'blog--current-cat',
	          onClick: this.blogNavDrop },
	        this.props.categoryFilter,
	        _react2.default.createElement('span', { className: 'fas fa-angle-down' })
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Filter by category'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'blog--navlist ' + this.state.navToggle },
	        blogNav
	      )
	    );
	  };
	
	  return BlogNav;
	}(_react.Component);
	
	BlogNav.propTypes = {
	  categoryFilter: _propTypes2.default.string,
	  categorySlug: _propTypes2.default.string,
	  drupalCategory: _propTypes2.default.array
	};
	
	exports.default = BlogNav;
	module.exports = exports['default'];

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _headerNew = __webpack_require__(26);
	
	var _headerNew2 = _interopRequireDefault(_headerNew);
	
	var _footerNew = __webpack_require__(15);
	
	var _footerNew2 = _interopRequireDefault(_footerNew);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _blogNav = __webpack_require__(400);
	
	var _blogNav2 = _interopRequireDefault(_blogNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var summaryBlog = function summaryBlog(html) {
	  /** TODO:
	   * Use the user providedsummary field if available.
	   *
	   * https://github.com/attn/attn-cms/pull/39#issuecomment-400160791
	   */
	
	  var convertHtml = html.replace(/<[^>]+>/g, '');
	  var wordsHtml = convertHtml.split(' ');
	  var summary = wordsHtml.reduce(function (brief, word, count) {
	    return count < 50 ? brief + ' ' + word : brief;
	  });
	
	  return summary + '...';
	}; /* global graphql */
	
	
	var BlogPage = function BlogPage(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	
	  var blogList = [];
	  var categoryFilter = pathContext.categorySlug || 'All';
	  var drupalCategory = data.allDrupalCategory !== null ? data.allDrupalCategory.edges : null;
	
	  if (data.allDrupalBlog) {
	    blogList = data.allDrupalBlog.edges.map(function (blog, ind) {
	      var _blog$node = blog.node,
	          title = _blog$node.title,
	          date = _blog$node.date,
	          category = _blog$node.category,
	          author = _blog$node.author,
	          body = _blog$node.body;
	
	      var bodyText = summaryBlog(body.value);
	      var slug = blog.node.url.path.replace(/^\/blogs\//, '/blog/');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'blog--post', key: ind },
	        _react2.default.createElement(
	          'div',
	          { className: 'blog--category' },
	          category.entity.title
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: slug },
	          _react2.default.createElement(
	            'h2',
	            null,
	            title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'blog--author-date' },
	          'By ',
	          author[0].entity.title,
	          ' \u2022 ',
	          date.value
	        ),
	        _react2.default.createElement('div', { className: 'blog__summary', dangerouslySetInnerHTML: { __html: bodyText } }),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'link--primary', to: slug },
	          'Read More'
	        )
	      );
	    });
	  } else {
	    blogList[0] = _react2.default.createElement(
	      'div',
	      { key: 1, className: 'blog--category-blank' },
	      'Sorry, there are no blog posts in this category.'
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'page--blog-index' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Updates - ATTN:' }),
	    _react2.default.createElement(_headerNew2.default, { hideOnScroll: false, fixed: true }),
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper--page wrapper--max-width wrapper--fixed-nav' },
	      _react2.default.createElement('div', { className: 'graphics--blog-circle' }),
	      _react2.default.createElement('div', { className: 'graphics--blog-dot' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'hero' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'UPDATES'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'blog--page' },
	        _react2.default.createElement(_blogNav2.default, {
	          categoryFilter: categoryFilter,
	          categorySlug: pathContext.categorySlug,
	          drupalCategory: drupalCategory }),
	        _react2.default.createElement(
	          'div',
	          { className: 'blog--post-list' },
	          blogList
	        )
	      )
	    ),
	    _react2.default.createElement(_footerNew2.default, null)
	  );
	};
	
	BlogPage.propTypes = {
	  data: _propTypes2.default.object,
	  pathContext: _propTypes2.default.object
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = BlogPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-blog-index-js-33d47dd6f42fb3cdacdc.js